'use client';

export * from './namespace';
